import { render, staticRenderFns } from "./RiwayatDeposit.vue?vue&type=template&id=11dde8d6&scoped=true&"
import script from "./RiwayatDeposit.vue?vue&type=script&lang=js&"
export * from "./RiwayatDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dde8d6",
  null
  
)

export default component.exports